const Jobs = () => {
    return (
        <section id="jobs" className="p-5 bg-primary text-center text-light">
            <div className="container">
                <h1 className="fw-bold font-link pb-5 pt-5">فرصت های شغلی</h1>

                <h5 className="text-center font-link fw-bolder">
                    شرکت نرم افزاری "فراد" همیشه از همکاری با نیروی متخصص و به روز مفتخر خواهد بود. از این روی، این شرکت
                    جهت جذب و همکاری با نیرو های متخصص آماده است. همینطور این شرکت توان پرورش و آموزش نیرو های تازه کار و
                    کم تجربه تر را هم در سایه وجود نیروی متخصص دارد.
                    از تمامی عزیزانی که قصد همکاری با این شرکت را دارند دعوت به عمل می آید که رزومه خود را به آذرس ایمیل
                    : <strong className="text-warning">jobs@faraad.org</strong> ارسال نمایند.
                    مدیران این شرکت در بخش نیروی انسانی رزومه های رسیده را بررسی می کنند و در اسرع وقت پاسخ شما عزیزان
                    را از طریق ایمیل یا تماس تلفنی خواهند داد.
                </h5>
            </div>
        </section>
    );
}

export default Jobs;